import { GeneralTickCircle } from "@fanduel/formation-react-icons";
import styles from "./Shared.module.scss";

const Shared = () => (
  <div className={styles.container}>
    <GeneralTickCircle />
    <span> Link successfuly copied!</span>
  </div>
);

export default Shared;
